import Vue from "vue";
import Router from "vue-router";
import LoginApphiPage from "../pages/login/Apphi.vue";
import LoginInstagramPage from "../pages/login/Instagram.vue";
import DownloadPage from "../pages/login/Download.vue";
import MyPlanPage from "../pages/my_plan/Index.vue";
import MyPlanEmailPage from "../pages/my_plan/Email.vue";
import MyPlanAddInstagramPage from "../pages/my_plan/AddInstagram.vue";
import AddAutoPostPage from "../pages/auto_post_account/AddAutoPost.vue";
import ModifyAutoPostPage from "../pages/auto_post_account/ModifyAutoPost.vue";
import MyPlanMemberDetailPage from "../pages/team_member/MemberDetail.vue";
import TeamMemberInstagramMorePage from "../pages/team_member/InstagramMore";
import TeamMemberListPage from "../pages/team_member/List";
import TeamMemberInviteMemberPage from "../pages/team_member/InviteMember.vue";
import TeamMemberAssignInstagramPage from "../pages/team_member/AssignInstagram.vue";
import TeamMemberAddInstagramAccountPage from "../pages/team_member/AddInstagramAccount.vue";
import ActivePage from "../pages/active/Index.vue";
import PaymentSubscriptionPage from "../pages/payment/Subscription.vue";
import PaymentSuccessPage from "../pages/payment/Success.vue";
import PaymentHistoryPage from "../pages/payment/History.vue";
import PaymentBillingPage from "../pages/payment/Billing.vue";
import PaymentBillingEditPage from "../pages/payment/BillingEdit.vue";
import PaymentBillingPayPalPage from "../pages/payment/BillingPayPal.vue";
import PaymentUpgradePage from "../pages/payment/Upgrade.vue";
import ValidateHomePage from "../pages/validate/Home.vue";
import ValidateCommentPage from "../pages/validate/Comment.vue";
import ValidateTagPeoplePage from "../pages/validate/TagPeople.vue";
import ValidateTagProductPage from "../pages/validate/TagProduct.vue";
import ValidateDownloadPage from "../pages/validate/Download.vue";
import CancelDetailPage from "../pages/cancel_plan/Detail.vue";
import CancelFeedbackPage from "../pages/cancel_plan/Feedback.vue";
import CancelOfferPage from "../pages/cancel_plan/Offer.vue";
import { autoLogin } from "../services/users";
import { showErrorMsg } from "../utils/error";
import store from "../store/index";
import { PARAMS } from "../store/mutation-types";

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: "/",
      name: "LoginApphiPage",
      component: LoginApphiPage,
    },
    {
      path: "/cancel/detail",
      name: "CancelDetailPage",
      component: CancelDetailPage,
    },
    {
      path: "/cancel/feedback",
      name: "CancelFeedbackPage",
      component: CancelFeedbackPage,
    },
    {
      path: "/cancel/offer",
      name: "CancelOfferPage",
      component: CancelOfferPage,
    },
    {
      path: "/login/instagram",
      name: "LoginInstagramPage",
      component: LoginInstagramPage,
    },
    {
      path: "/login/download",
      name: "DownloadPage",
      component: DownloadPage,
    },
    {
      path: "/my_plan",
      name: "MyPlanPage",
      component: MyPlanPage,
    },
    {
      path: "/my_plan/email",
      name: "MyPlanEmailPage",
      component: MyPlanEmailPage,
    },
    {
      path: "/my_plan/linked_instagram",
      name: "MyPlanAddInstagramPage",
      component: MyPlanAddInstagramPage,
    },
    {
      name: "AddAutoPostPage",
      path: "/my_plan/add_auto_post",
      component: AddAutoPostPage,
    },
    {
      name: "ModifyAutoPostPage",
      path: "/my_plan/modify_auto_post",
      component: ModifyAutoPostPage,
    },
    {
      name: "MyPlanMemberDetailPage",
      path: "/team_member/detail/:id",
      component: MyPlanMemberDetailPage,
    },
    {
      name: "TeamMemberInstagramMorePage",
      path: "/team_member/detail/:id/more",
      component: TeamMemberInstagramMorePage,
    },
    {
      name: "TeamMemberListPage",
      path: "/team_member/more",
      component: TeamMemberListPage,
    },
    {
      name: "TeamMemberInviteMemberPage",
      path: "/team_member/invite_member",
      component: TeamMemberInviteMemberPage,
    },
    {
      name: "TeamMemberAssignInstagramPage",
      path: "/team_member/assign_Instagram/:email",
      component: TeamMemberAssignInstagramPage,
    },
    {
      name: "TeamMemberAddInstagramAccountPage",
      path: "/team_member/add_Instagram_account/:id",
      component: TeamMemberAddInstagramAccountPage,
    },
    {
      path: "/active",
      name: "ActivePage",
      component: ActivePage,
    },
    {
      path: "/payment/pay/:name",
      name: "PaymentSubscriptionPage",
      component: PaymentSubscriptionPage,
    },
    {
      path: "/payment/upgrade/:type",
      name: "PaymentUpgradePage",
      component: PaymentUpgradePage,
    },
    {
      path: "/payment_success",
      name: "PaymentSuccessPage",
      component: PaymentSuccessPage,
    },
    {
      path: "/payment/history",
      name: "PaymentHistoryPage",
      component: PaymentHistoryPage,
    },
    {
      path: "/payment/billing",
      name: "PaymentBillingPage",
      component: PaymentBillingPage,
    },
    {
      path: "/payment/billing/edit",
      name: "PaymentBillingEditPage",
      component: PaymentBillingEditPage,
    },
    {
      path: "/payment/billing/paypal",
      name: "PaymentBillingPayPalPage",
      component: PaymentBillingPayPalPage,
    },
    {
      path: "/posts/:token/home",
      name: "ValidateHomePage",
      component: ValidateHomePage,
    },
    {
      path: "/posts/comment",
      name: "ValidateCommentPage",
      component: ValidateCommentPage,
    },
    {
      path: "/posts/tagPeople",
      name: "ValidateTagPeoplePage",
      component: ValidateTagPeoplePage,
    },
    {
      path: "/posts/tagProduct",
      name: "ValidateTagProductPage",
      component: ValidateTagProductPage,
    },
    {
      path: "/posts/download",
      name: "ValidateDownloadPage",
      component: ValidateDownloadPage,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    // 如果保存过位置则返回保存位置 否则返回头部位置
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});
router.beforeEach(async (to, from, next) => {
  // 获取请求参数
  const params = to.query;
  // 如果url上不存在timestamp参数，则说明不是通过app跳转
  if (!params.timestamp) {
    next();
    return;
  }
  const loading = new Vue().$loading;
  // 判断如果原页面和当前页面一致，且url时间戳和缓存时间戳不同则刷新页面
  const historyTimestamp =
    store.getters[PARAMS] === null ? 0 : store.getters[PARAMS].timestamp; // 上次打开时间戳
  const currentTimestamp = params.timestamp;
  if (historyTimestamp !== currentTimestamp) {
    try {
      loading.show();
      await autoLogin({ params });
      window.location.reload();
      next();
    } catch (e) {
      showErrorMsg(e);
      next({ name: "LoginApphiPage" });
    } finally {
      loading.hide();
    }
  } else {
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js